export default __webpack_public_path__ + "static/media/Category_385x420 copy 2.c26c0995.jpg";